import React, { useState } from 'react';
import CountUp from 'react-countup';
import ScrollTrigger from 'react-scroll-trigger';

const HappyClients = () => {
    const [countOn, setCountOn] = useState(false);
    return (
        <div className='pb-20 max-w-[1400px] m-auto'>
            <ScrollTrigger className='px-5 md:px-20 lg:px-32 flex flex-col md:flex-row lg:flex-row gap-4 justify-between opacity-80' onEnter={() => setCountOn(true)} onExit={() => setCountOn(false)}>
                <div className="p-10 bg-indigo-900 transition-all ease-in duration-300 hover:bg-indigo-800 rounded w-full text-center">
                    {
                        countOn &&
                        <CountUp className='text-5xl font-medium' start={0} end={3} duration={2} delay={0}></CountUp>
                    }<span className='text-4xl font-medium'>+ years</span>
                    <h1 className='text-3xl mt-3 font-medium'>Experiences</h1>
                </div>
                <div className="p-10 bg-indigo-900 transition-all ease-in duration-300 hover:bg-indigo-800 rounded w-full text-center">
                    {
                        countOn &&
                        <CountUp className='text-5xl font-medium' start={0} end={10} duration={2} delay={0}></CountUp>
                    }<span className='text-4xl font-bold'>+</span>
                    <h1 className='text-3xl mt-3 font-medium'>Happy Clients</h1>
                </div>
                <div className="p-10 bg-indigo-900 transition-all ease-in duration-300 hover:bg-indigo-800 rounded w-full text-center">
                    {
                        countOn &&
                        <CountUp className='text-5xl font-medium' start={0} end={60} duration={2} delay={0}></CountUp>
                    }<span className='text-4xl font-bold'>+</span>
                    <h1 className='text-3xl mt-3 font-medium'>Projects</h1>
                </div>
            </ScrollTrigger>
        </div>
    );
};

export default HappyClients;